{
    "name": "uptime-datacenter-planner",
    "version": "1.1.2",
    "private": true,
    "type": "module",
    "scripts": {
        "build": "bun run check && vite build",
        "check": "bun run typecheck && bun run lint && bun run test",
        "dev": "vite --host localhost --port 5173 --strictPort",
        "hardware:sync": "bun scripts/sync-wiki-hardware.ts",
        "maps:sync": "bun scripts/sync-wiki-maps.ts",
        "wiki:sync": "bun run hardware:sync && bun run maps:sync",
        "format": "biome format --write src scripts vite.config.ts package.json tsconfig.json biome.json",
        "lint": "biome check src scripts vite.config.ts package.json tsconfig.json biome.json",
        "test": "vitest run",
        "typecheck": "tsc --noEmit"
    },
    "dependencies": {
        "@fontsource-variable/inter": "^5.3.0",
        "@fontsource-variable/jetbrains-mono": "^5.3.0",
        "@fontsource/nova-square": "^5.3.0",
        "@vitejs/plugin-react": "latest",
        "react": "latest",
        "react-dom": "latest",
        "vite": "latest"
    },
    "devDependencies": {
        "@biomejs/biome": "latest",
        "@types/bun": "^1.3.14",
        "@types/react": "latest",
        "@types/react-dom": "latest",
        "typescript": "latest",
        "vitest": "latest"
    }
}
